<template lang="pug">
  div(:class='`bindEmail`')
    van-form
        van-field(class="bind_form", v-model="email", :placeholder="$t('inputBindEmail')", :rules="[{ required: true, message: this.$t('noEmail') },{ pattern: /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/, message: this.$t('emailPatternErr')}]")
        van-field(class="bind_code", v-model="code", :placeholder="$t('inputCode')")
            template(#button)
        van-button(class="bind_btn", size="small", type="danger", block, round, :disabled="disabled", @click="sendHandle") {{sendCode}}
        van-button(class="bind_btn", native-type="submit", type="danger", block, round, @click="onSubmit", :disabled='isDisabled') {{$t('bind')}}
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import { Toast } from 'vant';
export default {
  name: 'BindEmail',
  data($vm){
    return{
      email: '',
      code: '',
      isDisabled: false,
      disabled: false,
      sendCode: $vm.$t('sendCode'),
    }
  },
  created(){
  },
  methods:{
      ...mapActions(['getUserInfo']),
      ...mapActions('user', ['sendEmailCode', 'checkEmailCode']),
      onSubmit(){
        if(/^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(this.email)){
          if(this.code){
            if(!this.isDisabled){
              this.checkEmailCode(Qs.stringify({
                uid: this.uid,
                deviceId: this.deviceId,
                accessToken: this.token,
                email: this.email,
                code: this.code
              }))
              this.isDisabled = true
            }
          }
        }
      },
      sendHandle(){
        if(/^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(this.email)){
          this.sendEmailCode(Qs.stringify({
            uid: this.uid,
            deviceId: this.deviceId,
            accessToken: this.token,
            email: this.email,
            language: this.lang,
            appId: this.appid
          }))
        }
      }
  },
  computed:{
      ...mapGetters(['loading', 'uid', 'deviceId', 'token', 'appid', 'isNewUploadLog', 'lang']),
      ...mapGetters('user', ['errmsg', 'sending', 'sendState', 'checking', 'checkState'])
  },
  mounted(){
    this.$watch('sending', val => {
      if(val === 'sended'){
        if(this.sendState == 'success'){
          Toast.success(this.$t('sended'))
          this.disabled = true
          let count = 60
          let interval = setInterval(() => {
            if(count === 0){
              this.disabled = false
              this.sendCode = this.$t('sendCode')
              clearInterval(interval)
            } else {
              count--
              this.sendCode = count + this.$t('retry')
            }
          }, 1000)
        }
      }
    })
    this.$watch('checking', val => {
      if(val === 'checked'){
        // console.log(this.checkState)
        if(this.checkState === 'success'){
          if(this.isNewUploadLog){
            window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.uploadEmail.postMessage({uid: this.uid, emailAddress: this.email})
          }
          this.getUserInfo(Qs.stringify({
            appId: this.appid,
            uid: this.uid,
            deviceId: this.deviceId,
            accessToken: this.token
          }));
          this.$router.push({
            path: '/user/bindSuccess',
            query: {
              email: this.email
            }
          });
        } else {
          this.isDisabled = false
        }
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.bindEmail{
    margin: 20px;
    .bind_form{
      margin-top: 20px;
      border-radius: 5px;
      box-shadow: 0px 0px 5px 2px #ebebeb;
    }
    .bind_code{
      margin-top: 20px;
      border-radius: 5px;
      box-shadow: 0px 0px 5px 2px #ebebeb;
    }
    .bind_btn{
        margin-top: 20px;
        width: 90%;
        left: 5%;
        padding: 15px;
    }
}
</style>